/* eslint-disable
    @typescript-eslint/no-this-alias,
    */
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */

import React from 'react';
import Promise from 'bluebird';
// @ts-expect-error TS(7016): Could not find a declaration file for module 'prom... Remove this comment to see the full error message
import Queue from 'promise-queue';
import _ from 'underscore';

import { Analytics, formatContainers } from '@trello/atlassian-analytics';
import { isTouch } from '@trello/browser';
import { ApiError, makeErrorEnum } from '@trello/error-handling';
// eslint-disable-next-line no-restricted-imports
import $ from '@trello/jquery';
import { getKey, isArrow, Key } from '@trello/keybindings';
import { smartCardClient } from '@trello/smart-card/smart-card-client';
import { guardedTrim } from '@trello/strings';

// eslint-disable-next-line no-restricted-imports
import { Controller } from 'app/scripts/controller';
import { l } from 'app/scripts/lib/localize';
import { Util } from 'app/scripts/lib/util';
import { maybeDisplayLimitsErrorOnCardAdd } from 'app/scripts/views/card/CardLimitsError';
import { trackSeparator } from 'app/scripts/views/card/SeparatorCard/SeparatorCard';
import { ComposerMemberSelectorView } from 'app/scripts/views/card-composer/ComposerMemberSelectorView';
import { ComposerPosSelectorView } from 'app/scripts/views/card-composer/ComposerPosSelectorView';
import { ComposerSelectorMenuView } from 'app/scripts/views/card-composer/ComposerSelectorMenuView';
import { templates } from 'app/scripts/views/internal/templates';
import { View } from 'app/scripts/views/internal/view';
import { Alerts } from 'app/scripts/views/lib/Alerts';
import { Confirm } from 'app/scripts/views/lib/Confirm';
import { PopOver } from 'app/scripts/views/lib/PopOver';
import { CardComposerInlineTemplate } from 'app/scripts/views/templates/CardComposerInlineTemplate';
import { MemberTemplate } from 'app/scripts/views/templates/MemberTemplate';
import { CardFrontLabels } from 'app/src/components/CardViewLabels/CardFrontLabels';
import {
  ComponentWrapper,
  renderComponent,
} from 'app/src/components/ComponentWrapper';
import { LazyCardComposerLabelsList } from 'app/src/components/LabelsPopover';
import { stopPropagationAndPreventDefault } from 'app/src/stopPropagationAndPreventDefault';

/* eslint-disable-next-line @trello/enforce-variable-case, @trello/no-module-logic */
const CardComposerError = makeErrorEnum('CardComposer', ['TooManyCards']);

const MAX_PARALLEL_CARD_CREATION = 5;
const MAX_CARD_TITLE_LENGTH = 16384;

interface CardComposerInlineView {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  $el: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  _cardCreationApiQueue: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  defer: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  el: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  frameDebounce: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  listenTo: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  makeDebouncedMethods: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  model: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  modelCache: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  unmountLabels: any;
}

// @ts-expect-error TS(2707): Generic type 'View<TOptions, TModel>' requires bet... Remove this comment to see the full error message
class CardComposerInlineView extends View {
  className() {
    return 'card-composer';
  }

  events() {
    return {
      'click .js-add-card': 'submitCard',
      'click .js-cancel': 'clearAndHide',
      'click .js-cc-menu': 'openMenu',

      keyup: 'keyupEvent',
      paste: 'pasteEvent',
      keydown: 'keydownEvent',
    };
  }

  initialize() {
    this.makeDebouncedMethods('render');

    this.listenTo(
      this.model,
      'change:idLabels change:idMembers',
      this.renderSelectedItems,
    );
    this.listenTo(this.model, 'change:vis', this.autosaveCard);
    this.listenTo(
      this.model.labelList,
      'add remove reset change',
      this.frameDebounce(this.renderSelectedItems),
    );

    this._cardCreationApiQueue = new Queue(MAX_PARALLEL_CARD_CREATION);

    this.handleClickOutside = this.handleClickOutside.bind(this);
    $(document).on('click', this.handleClickOutside);
  }

  remove() {
    $(document).off('click', this.handleClickOutside);
    this.unmountLabels?.();
    return super.remove(...arguments);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  handleClickOutside(event: any) {
    // We aren't interested in this event if the card composer is not open
    if (!this.model.get('vis')) {
      return;
    }

    // eslint-disable-next-line @trello/enforce-variable-case
    const $target = $(event.target);

    // We deem the click 'outside' the the card composer if the click wasn't within it's
    // panel, or within the popover that can be used to add Members/Labels etc to the Card
    const wasClickOutside =
      $target.closest('.card-composer').length === 0 &&
      $target.closest('.pop-over').length === 0 &&
      $target.closest('.pop-over-content').length === 0;
    if (wasClickOutside) {
      return this.model.save('vis', false);
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  render(args: any, callback: any) {
    Analytics.sendScreenEvent({
      name: 'inlineCardComposerInlineDialog',
      containers: formatContainers({
        idBoard: this.model.getBoard()?.id,
        idList: this.model.attributes?.list.id,
        idOrganization: this.model.getBoard()?.getOrganization()?.id,
      }),
    });

    const data = {
      placeholder: this.getPlaceholder(),
      ...this.model.toJSON({ board: true }),
    };

    // this toggles classes so lets do it before adding stuff to the DOM
    this.renderVisibility();

    this.$el.html(templates.fill(CardComposerInlineTemplate, data));

    this.renderSelectedItems();

    this.defer(() => {
      // we could focus().select() here, but it might override what was typed
      // in the time between submitting the card and getting it
      // back from the server.
      Util.setCaretAtEnd(this.el.querySelector('.js-card-title'));

      // will select card with this callback if we just submitted a card
      return typeof callback === 'function' ? callback() : undefined;
    });

    // @ts-expect-error TS(2339): Property 'autosize' does not exist on type 'JQuery... Remove this comment to see the full error message
    $('.js-card-title', this.$el).autosize();

    return this;
  }

  autosaveCard() {
    const val = this.getCardTitle();
    // Check placeholder value because of IE bug where it will save the placeholder
    if (
      val !== '' &&
      val !== this.getPlaceholder() &&
      val.length <= MAX_CARD_TITLE_LENGTH
    ) {
      return this.submitCard(null, { addedFromAutosave: true });
    } else {
      return this.frameDebounce(this.renderVisibility());
    }
  }

  renderVisibility() {
    this.$el.toggleClass('hide', !this.model.get('vis'));
    return this;
  }

  clearTextField() {
    this.model.save('title', '');
    return $('.js-card-title', this.$el).val('').trigger('autosize.resize');
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  submitCard(e: any, opts = { addedFromAutosave: false }) {
    if (e) {
      stopPropagationAndPreventDefault(e);
    }

    // Hide 'add label', 'select members', etc. popovers
    PopOver.hide();

    const s = this.getCardTitle();

    if (s === '') {
      this.$el.find('.js-card-title').focus().select();
      return;
    }

    if (s.length > MAX_CARD_TITLE_LENGTH) {
      this.$el.find('.js-card-title').focus().select();
      Alerts.flash('card title too long', 'error', 'card-composer');
      return;
    }

    // eslint-disable-next-line @trello/enforce-variable-case
    const $manyCardsPopOverTarget = e ? $(e.target) : this.$el;
    const options = {
      $elem: $manyCardsPopOverTarget,
      destinationBoard: this.model.getBoard(),
      destinationList: this.model.getList(),
    };
    if (maybeDisplayLimitsErrorOnCardAdd(options)) {
      return;
    }

    const cardTitles = _.compact(s.split(/\r\n|\r|\n/));
    const count = cardTitles.length;
    const countString = count.toString();

    Promise.try(() => {
      if (count > 100) {
        throw new CardComposerError.TooManyCards();
      }

      if (count > 1 && !opts.addedFromAutosave) {
        return new Promise((resolve) =>
          Confirm.toggle('create many cards', {
            elem: $manyCardsPopOverTarget,
            html: l('confirm.create many cards.text', { count: countString }),
            confirmText: l('confirm.create many cards.confirm', {
              count: countString,
            }),
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            fxConfirm: (e: any) => resolve(true),
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            fxCancel: (e: any) => resolve(false),
          }),
        );
      } else {
        return false;
      }
    })
      .then((createOnePerLine) => {
        this.clearTextField();
        const openCard = e?.shiftKey === true;

        if (createOnePerLine) {
          this.createMultipleCards(cardTitles, openCard);
        } else {
          // Dont select the card in autocreate card experiment so that a user
          // can use keyboard on board after creating card
          this.createCard(s, {
            openCard,
            selectCard: !opts.addedFromAutosave,
            removeNewLines: true,
          }).catch(ApiError, () =>
            Alerts.flash('could not connect', 'error', 'card-composer'),
          );
        }

        // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
        return this.clearItems();
      })
      .then(() => {
        if (opts.addedFromAutosave) {
          // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
          this.hide();
          return this.renderVisibility();
        }
      })
      .catch(CardComposerError.TooManyCards, () =>
        // too many cards
        Confirm.toggle('too many cards', {
          elem: $manyCardsPopOverTarget,
          html: l('confirm.too many cards.text', { count: countString }),
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          fxConfirm: (e: any) => PopOver.hide(),
        }),
      )
      .done();
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  queueCreateCard(title: any, params = {}) {
    // @ts-expect-error TS(2339): Property 'requestData' does not exist on type '{}'... Remove this comment to see the full error message
    params.requestData = this._createCardRequestData(
      title,
      // @ts-expect-error TS(2339): Property 'removeNewLines' does not exist on type '... Remove this comment to see the full error message
      params.removeNewLines,
    );
    return this._cardCreationApiQueue.add(() => this.createCard(title, params));
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  _createCardRequestData(title: any, removeNewLines: any) {
    title = guardedTrim(title);

    this.$el.trigger('prevent-scroll-selection');

    if (removeNewLines) {
      title = title.replace(/(\r\n|\n|\r)/gm, ' ');
    }

    // clone members and labels you added
    const membersToAdd = _.clone(this.model.get('idMembers'));
    const idLabelsToAdd = _.pluck(this.model.labelList.models, 'id');

    const newCardData = {
      name: title,
      closed: false,
      idLabels: idLabelsToAdd,
      idMembers: membersToAdd,
      dateLastActivity: Date.now(),
    };

    const addsLabels = idLabelsToAdd.length > 0;

    return { newCardData, addsLabels, membersToAdd };
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  createCard(title: any, param = {}) {
    // @ts-expect-error TS(2339): Property 'openCard' does not exist on type '{}'.
    const { openCard, selectCard, removeNewLines, requestData } = param;
    return new Promise((resolve, reject) => {
      const { newCardData, addsLabels, membersToAdd } =
        requestData ?? this._createCardRequestData(title, removeNewLines);

      if (title === '') {
        return resolve();
      } else {
        const traceId = Analytics.startTask({
          taskName: 'create-card/list',
          source: 'inlineCardComposerInlineDialog',
        });
        // pos needs to be calculated immediately before insertion
        newCardData.pos = this.model.getList().calcPos(this.model.get('index'));
        this.model.moveToNext();

        const card = this.model
          .getList()
          .cardList.createWithTracing(newCardData, {
            traceId: traceId,
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            error: (model: any, error: any) => {
              this.model.getList().cardList.remove(card);
              Analytics.taskFailed({
                taskName: 'create-card/list',
                traceId,
                source: 'inlineCardComposerInlineDialog',
                error,
              });
              return reject(error);
            },

            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            success: async (card: any) => {
              let linkCardProvider = undefined;
              const cardRole = card?.getCardRole();

              if (cardRole === 'link') {
                const url = card.get('name');
                const resolvedUrl = await smartCardClient
                  .fetchData(url)
                  .catch(() => {});

                if (resolvedUrl?.meta) {
                  linkCardProvider =
                    resolvedUrl.meta.key || resolvedUrl.meta.definitionId;
                }
              }

              Analytics.sendTrackEvent({
                action: 'created',
                actionSubject: 'card',
                source: 'inlineCardComposerInlineDialog',
                attributes: {
                  numMembersAdded: membersToAdd?.length,
                  labelsAdded: addsLabels,
                  taskId: traceId,
                  cardRole,
                  linkCardProvider,
                },
                containers: formatContainers({
                  idCard: card?.id,
                  idList: card?.getList()?.id,
                  idBoard: card?.getBoard()?.id,
                  idOrganization: card?.getBoard()?.getOrganization()?.id,
                }),
              });

              // @ts-expect-error TS(2554): Expected 1 arguments, but got 2.
              trackSeparator(title, {
                category: 'card composer',
                method: 'by creating a card',
              });

              Analytics.taskSucceeded({
                taskName: 'create-card/list',
                traceId,
                source: 'inlineCardComposerInlineDialog',
              });

              const board = this.model.getBoard();
              board.filter.addNewCard(card);

              if (selectCard) {
                board.viewState.selectCard(card);
              }

              if (openCard) {
                Analytics.sendPressedShortcutEvent({
                  shortcutName: 'createAndOpenCardShortcut',
                  keyValue: Key.Enter,
                  source: 'inlineCardComposerInlineDialog',
                  containers: formatContainers({
                    idCard: card?.id,
                    idList: card?.getList()?.id,
                    idBoard: card?.getBoard()?.id,
                    idOrganization: card?.getBoard()?.getOrganization()?.id,
                  }),
                });
                Controller.showCardDetail(card, {
                  runMethod: card?.shouldSuggestDescription()
                    ? 'expandDesc'
                    : undefined,
                  method: 'via the Shift shortcut from card composer',
                });
              }

              resolve();
            },
            modelCache: this.modelCache,
          });
      }
    });
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  createMultipleCards(cardTitles: any, openCard: any) {
    const numCardsLength = cardTitles.length;

    for (let i = 0; i < cardTitles.length; i++) {
      const title = cardTitles[i];
      if (cardTitles.length - 1 === i) {
        this.queueCreateCard(title, { openCard, selectCard: true });
      } else {
        this.queueCreateCard(title);
      }
    }

    Analytics.sendTrackEvent({
      action: 'created',
      actionSubject: 'multipleCards',
      source: 'createMultipleCardsInlineDialog',
      attributes: {
        numCardsLength,
      },
      containers: formatContainers({
        idBoard: this.model.getBoard()?.id,
        idList: this.model.attributes?.list.id,
        idOrganization: this.model.getBoard()?.getOrganization()?.id,
      }),
    });
  }

  pasteEvent() {
    $('.js-card-title', this.$el).focus().keyup().trigger('autosize.resize');
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  keydownEvent(e: any) {
    const key = getKey(e);
    // eslint-disable-next-line @trello/enforce-variable-case
    const $titleInput = $('.js-card-title', this.$el);
    const isTitle = $(e.target)
      .closest('.js-card-title')
      .hasClass('js-card-title');
    const isJsAddCard = $(e.target)
      .closest('.js-add-card')
      .hasClass('js-add-card');

    if ((isTitle || isJsAddCard) && !PopOver.isVisible && key === Key.Enter) {
      stopPropagationAndPreventDefault(e);
      this.submitCard(e, { addedFromAutosave: false });
      return;
    }

    if (key === Key.Escape) {
      return this.saveDraftAndHide();
      // @ts-expect-error TS(2345): Argument of type 'string' is not assignable to par... Remove this comment to see the full error message
    } else if ([Key.Tab, Key.Enter].includes(key)) {
      $titleInput.focus();

      const word = Util.getWordFromCaret($titleInput[0]);

      const poEl = $(PopOver.view?.el);

      let found = false;

      // @ts-expect-error TS(2359): The right-hand side of an 'instanceof' expression ... Remove this comment to see the full error message
      if (PopOver.view instanceof ComposerMemberSelectorView) {
        poEl
          .find('.js-members-list .item.selected:first .js-select-member')
          .first()
          .click();
        found = true;
        // @ts-expect-error TS(2359): The right-hand side of an 'instanceof' expression ... Remove this comment to see the full error message
      } else if (PopOver.view instanceof ComposerPosSelectorView) {
        if (poEl.find('.js-pos-results').length > 0) {
          poEl.find('.js-pos-results li.selected:first a').first().click();
          found = true;
        }
      } else if (
        PopOver.displayType === LazyCardComposerLabelsList.displayName
      ) {
        $(`.${LazyCardComposerLabelsList.displayName}`)
          .find('.js-labels-list-item.selected')
          .first()
          .click();
        found = true;
      } else if (key === Key.Tab && $titleInput.val() === '') {
        stopPropagationAndPreventDefault(e);
        // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
        this.hide();
        if (e.shiftKey) {
          $(this.el)
            .closest('.js-list')
            .find('.editable:first .current')
            .click();
        } else {
          $(this.el)
            .closest('.js-list')
            .next()
            .find('.editable:first .current')
            .click();
        }
      }

      if (found) {
        stopPropagationAndPreventDefault(e);
        Util.insertSelection($titleInput, '', word.start, word.end);
        this.model.set('title', $titleInput.val());
      }

      this.renderSelectedItems();
      PopOver.hide();
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  keyupEvent(e: any) {
    // eslint-disable-next-line @trello/enforce-variable-case
    const $titleInput = $('.js-card-title', this.$el);

    const key = getKey(e);

    // @ts-expect-error TS(2345): Argument of type 'string' is not assignable to par... Remove this comment to see the full error message
    if ([Key.Tab, Key.Enter].includes(key)) {
      return;
    }

    if (key === Key.Escape) {
      stopPropagationAndPreventDefault(e);
      PopOver.hide();
      $titleInput.focus();
      return;
    }

    // navigate menu list
    if (isArrow(key)) {
      stopPropagationAndPreventDefault(e);

      const poEl = $(PopOver.view?.el);

      // @ts-expect-error TS(2359): The right-hand side of an 'instanceof' expression ... Remove this comment to see the full error message
      if (PopOver.view instanceof ComposerMemberSelectorView) {
        Util.navMenuList(poEl.find('.js-members-list'), '.item', key);
        // @ts-expect-error TS(2359): The right-hand side of an 'instanceof' expression ... Remove this comment to see the full error message
      } else if (PopOver.view instanceof ComposerPosSelectorView) {
        if (poEl.find('.js-pos-results').length > 0) {
          Util.navMenuList(poEl.find('.js-pos-results'), 'li', key);
        }
      } else if (
        PopOver.displayType === LazyCardComposerLabelsList.displayName
      ) {
        Util.navMenuList(
          $(`.${LazyCardComposerLabelsList.displayName}`),
          '.js-labels-list-item',
          key,
        );
      }

      return;
    }

    if (
      !isTouch() &&
      $(e.target).closest('.js-card-title').hasClass('js-card-title')
    ) {
      const word = Util.getWordFromCaret($titleInput[0]);
      const isMemberMatch = new RegExp(`^@\\S`).test(word.str.substring(0, 2));
      const isLabelMatch = new RegExp(`^\\#\\S`).test(word.str.substring(0, 2));
      const isPosMatch = new RegExp(`^\\^\\S`).test(word.str.substring(0, 2));
      const term = word.str.substring(1).toLowerCase();

      // if match members, labels, or positions
      if (isMemberMatch || isLabelMatch || isPosMatch) {
        // @ts-expect-error TS(2345): Argument of type 'string' is not assignable to par... Remove this comment to see the full error message
        if (![Key.Shift, Key.Alt, Key.Control].includes(key)) {
          let elem, view;
          if (isMemberMatch) {
            // @ts-expect-error TS(2351): This expression is not constructable.
            view = new ComposerMemberSelectorView({
              model: this.model,
              modelCache: this.modelCache,
            });

            const idBoardMems = _.pluck(
              this.model
                .getBoard()
                .memberList.filterDeactivated({ force: true }).models,
              'id',
            );
            const idMems = Util.filterMembers(
              this.modelCache,
              term,
              idBoardMems,
            );

            if (idMems.length > 0) {
              view.populate(idMems, true);

              PopOver.show({
                elem: $('.js-cc-menu', this.$el),
                view,
              });

              $titleInput.focus();
              elem = $(view.el).find('.js-members-list .item:first');
              return Util.selectMenuItem(
                $(view.el).find('.js-members-list'),
                '.item',
                elem,
              );
            } else {
              return PopOver.hide();
            }
          } else if (isLabelMatch) {
            const labelMatches = this.model.getBoard().filterLabels(term);
            if (!labelMatches?.length) {
              return PopOver.hide();
            }

            PopOver.show({
              elem: $('.js-cc-menu', this.$el),
              getViewTitle: () => l(['view title', 'select labels']),
              // This is magic: `displayType` is an escape hatch in PopOver
              // that lets us apply anything to the PopOver's classList.
              // We use it for query selectors here because React PopOvers
              // don't have `PopOver.view?.el` defined.
              displayType: LazyCardComposerLabelsList.displayName,
              reactElement: (
                <ComponentWrapper key="card-composer-labels-list">
                  <LazyCardComposerLabelsList
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    labels={labelMatches.map((l: any) => l.toCardLabelType())}
                    model={this.model}
                  />
                </ComponentWrapper>
              ),
            });

            $titleInput.focus();
          } else if (isPosMatch) {
            // @ts-expect-error TS(2351): This expression is not constructable.
            view = new ComposerPosSelectorView({
              model: this.model,
              modelCache: this.modelCache,
            });
            const posNames = view.filterPos(term);

            if (posNames.hasData) {
              view.populateResults(posNames);

              PopOver.show({
                elem: $('.js-cc-menu', this.$el),
                view,
              });

              $titleInput.focus();
              elem = $(view.el).find('.js-pos-results li:first');
              return Util.selectMenuItem(
                $(view.el).find('.js-pos-results'),
                'li',
                elem,
              );
            } else {
              return PopOver.hide();
            }
          }
        }
      } else {
        // add current text
        this.model.set('title', this.getCardTitle());

        return PopOver.hide();
      }
    }
  }

  renderSelectedItems() {
    // members
    const idMembers = this.model.get('idMembers');
    const hasMembers = !_.isEmpty(idMembers);
    // eslint-disable-next-line @trello/enforce-variable-case
    const $members = $('.js-list-card-composer-members', this.$el).empty();
    for (const mem of Array.from(this.modelCache.get('Member', idMembers))) {
      $members.append(
        `<div class='member js-remove-member' idMember='${mem}'>${MemberTemplate(
          // @ts-expect-error TS(2571): Object is of type 'unknown'.
          mem.toJSON(),
        )}</div>`,
      );
    }

    // labels
    const labels = this.model.get('labels');
    const hasLabels = !_.isEmpty(labels);
    // eslint-disable-next-line @trello/enforce-variable-case
    const $labels = $('.js-list-card-composer-labels', this.$el);

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const labelsOverride = this.model.labelList.models.map((l: any) =>
      l.toCardLabelType(),
    );
    this.unmountLabels = renderComponent(
      <CardFrontLabels labelsOverride={labelsOverride} />,
      $labels[0],
    );

    $('.js-clear-all-items', this.$el).toggle(hasLabels || hasMembers);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  openMenu(e: any) {
    stopPropagationAndPreventDefault(e);

    Analytics.sendClickedButtonEvent({
      buttonName: 'cardComposerMenuButton',
      source: 'inlineCardComposerInlineDialog',
      containers: formatContainers({
        idBoard: this.model.getBoard()?.id,
        idList: this.model.attributes.list.id,
        idOrganization: this.model.getBoard()?.getOrganization()?.id,
      }),
    });

    return PopOver.toggle({
      elem: e.target,
      // @ts-expect-error TS(2351): This expression is not constructable.
      view: new ComposerSelectorMenuView({
        model: this.model,
        modelCache: this.modelCache,
      }),
    });
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  clearItems(e: any) {
    return this.model.clearItems();
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  hide(e: any) {
    this.model.save('vis', false);
  }

  saveDraftAndHide() {
    this.model.save('title', this.getCardTitle());
    $('.js-card-title', this.$el).val('');
    // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
    return this.hide();
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  clearAndHide(e: any) {
    // Set title to nothing so that autosave doesn't save on close
    $('.js-card-title', this.$el).val('');
    // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
    this.clearItems();
    this.$el.toggleClass('hide', true);
    // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
    return this.hide();
  }

  scrollIntoView() {
    const { top } = this.$el.offset();
    const scrollable = this.$el.closest('.list-cards');

    return scrollable.scrollTop(top + this.$el.height());
  }

  getPlaceholder() {
    return l([
      'templates',
      'card_composer_inline',
      'enter-a-title-for-this-card-ellipsis',
    ]);
  }

  getCardTitle() {
    // @ts-expect-error TS(2345): Argument of type 'string | number | string[] | und... Remove this comment to see the full error message
    return guardedTrim($('.js-card-title', this.$el).val());
  }
}

export { CardComposerInlineView };
